export enum QuestionDifficultyLevel {
  EASY,
  NORMAL,
  HARD,
}
